"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VCarousel = void 0;
var core_1 = require("@blueprintjs/core");
var style_1 = require("./style");
var react_1 = __importStar(require("react"));
var react_pose_1 = __importStar(require("react-pose"));
var VCarousel = (function (_super) {
    __extends(VCarousel, _super);
    function VCarousel(props) {
        var _this = _super.call(this, props) || this;
        _this.changeElement = function (direction) {
            if (direction === 'LEFT') {
                _this.changeItemFromLeft();
            }
            else {
                _this.changeItemFromRight();
            }
        };
        _this.changeItemFromLeft = function (nextIndex) {
            if (nextIndex === void 0) { nextIndex = _this.state.activeIndex - 1; }
            _this.setState({
                fromLeft: true,
                fromRight: false,
                activeIndex: nextIndex,
                activeElement: null
            }, function () {
                _this.setState({
                    activeElement: _this.props.elements[_this.state.activeIndex]
                });
            });
        };
        _this.changeItemFromRight = function (nextIndex) {
            if (nextIndex === void 0) { nextIndex = _this.state.activeIndex + 1; }
            _this.setState({
                fromLeft: false,
                fromRight: true,
                activeIndex: nextIndex,
                activeElement: null
            }, function () {
                _this.setState({
                    activeElement: _this.props.elements[_this.state.activeIndex]
                });
            });
        };
        _this.state = {
            activeIndex: 0,
            fromLeft: false,
            fromRight: true,
            activeElement: _this.props.elements[0]
        };
        return _this;
    }
    VCarousel.prototype.render = function () {
        var _this = this;
        var _a = this.props, elements = _a.elements, buttonsJustify = _a.buttonsJustify, height = _a.height, width = _a.width;
        var _b = this.state, activeIndex = _b.activeIndex, fromLeft = _b.fromLeft, fromRight = _b.fromRight, activeElement = _b.activeElement;
        var CarouselDiv = react_pose_1.default.div({
            enter: {
                x: 0,
                opacity: 1,
                delay: 150,
                transition: {
                    x: { type: 'spring', stiffness: 1000, damping: 1000 },
                    default: { duration: 150 }
                }
            },
            exit: {
                x: (fromRight && 50) || (fromLeft && -50),
                opacity: 0,
                transition: {
                    x: function (_a) {
                        var from = _a.from, to = _a.to;
                        return ({
                            type: 'keyframes',
                            values: [from, (fromRight && -50) || (fromLeft && 50), to],
                            times: [0, 0.99, 1]
                        });
                    },
                    opacity: function (_a) {
                        var from = _a.from, to = _a.to;
                        return ({
                            type: 'keyframes',
                            values: [from, 0, to],
                            times: [0, 0.99, 1]
                        });
                    }
                }
            }
        });
        return (react_1.default.createElement(style_1.VStyledCarrouselContainer, { height: height, width: width },
            react_1.default.createElement(style_1.VStyledCarrousel, null,
                react_1.default.createElement(react_pose_1.PoseGroup, null, activeElement && [
                    react_1.default.createElement(CarouselDiv, { key: 'CarouselDivFromLeft' }, activeElement)
                ])),
            react_1.default.createElement(style_1.VStyledCarrouselButtonsContainer, { buttonsJustify: buttonsJustify },
                react_1.default.createElement(core_1.Button, { disabled: this.state.activeIndex === 0, minimal: true, icon: 'chevron-left', onClick: function () { return _this.changeElement('LEFT'); } }),
                react_1.default.createElement(core_1.Button, { disabled: this.state.activeIndex === elements.length - 1, minimal: true, icon: 'chevron-right', onClick: function () { return _this.changeElement('RIGHT'); } }))));
    };
    return VCarousel;
}(react_1.Component));
exports.VCarousel = VCarousel;
